import React from "react";
import { Link } from "react-router-dom";
import { MdArticle, MdImage, MdViewCarousel, MdForum, MdPerson } from "react-icons/md";

const actions = [
  {
    label: "Tambah Postingan",
    icon: <MdArticle className="h-5 w-5" />,
    to: "/admin/add-posts",
    color: "bg-green-50 text-green-600 hover:bg-green-100 dark:bg-green-500/20 dark:text-green-400 dark:hover:bg-green-500/30",
  },
  {
    label: "Tambah Galeri",
    icon: <MdImage className="h-5 w-5" />,
    to: "/admin/add-foto",
    color: "bg-purple-50 text-purple-600 hover:bg-purple-100 dark:bg-purple-500/20 dark:text-purple-400 dark:hover:bg-purple-500/30",
  },
  {
    label: "Tambah Carousel",
    icon: <MdViewCarousel className="h-5 w-5" />,
    to: "/admin/add-carousel",
    color: "bg-orange-50 text-orange-600 hover:bg-orange-100 dark:bg-orange-500/20 dark:text-orange-400 dark:hover:bg-orange-500/30",
  },
  {
    label: "Kelola Medsos",
    icon: <MdForum className="h-5 w-5" />,
    to: "/admin/medsos",
    color: "bg-blue-50 text-blue-600 hover:bg-blue-100 dark:bg-blue-500/20 dark:text-blue-400 dark:hover:bg-blue-500/30",
  },
  {
    label: "Kelola Pengguna",
    icon: <MdPerson className="h-5 w-5" />,
    to: "/admin/user",
    color: "bg-red-50 text-red-600 hover:bg-red-100 dark:bg-red-500/20 dark:text-red-400 dark:hover:bg-red-500/30",
  },
];

const QuickActions = () => {
  return (
    <div className="flex flex-col rounded-[20px] bg-white px-6 pb-4 pt-6 shadow-xl shadow-shadow-500 dark:bg-navy-800 dark:shadow-none">
      <h4 className="mb-4 text-lg font-bold text-navy-700 dark:text-white">
        Aksi Cepat
      </h4>
      <div className="flex flex-col gap-3">
        {actions.map((action) => (
          <Link
            key={action.to}
            to={action.to}
            className={`flex items-center gap-3 rounded-xl px-4 py-3 font-medium transition-all duration-150 ${action.color}`}
          >
            {action.icon}
            <span className="text-sm">{action.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
